import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {showLoading, hideLoading, showMessage, showMessageError, transDate, formatDate, formatTime, formatNumber, getDayOfWeek,
    showMessageWarning, showMessageSuccess, showConfirm, checkExistsList, storage} from './utils/utils'
import {api_url, Http} from './utils/http.js'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import './assets/css/style.css'
import 'nprogress/nprogress.css' //这个样式必须引入
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

const app = createApp(App)
// 全局注册element plus icon
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.config.globalProperties.$tpLoading = showLoading
app.config.globalProperties.$tpLoadend = hideLoading
app.config.globalProperties.$tpToast = showMessage
app.config.globalProperties.$tpFail = showMessageWarning
app.config.globalProperties.$tpSuccess = showMessageSuccess
app.config.globalProperties.$tpError = showMessageError
app.config.globalProperties.$tpConfirm = showConfirm
app.config.globalProperties.$http = new Http()
app.config.globalProperties.$apiUrl = api_url()
app.config.globalProperties.$exists = checkExistsList
app.config.globalProperties.$storage = storage
app.config.globalProperties.$transDate = transDate
app.config.globalProperties.$formatDate = formatDate
app.config.globalProperties.$formatTime = formatTime
app.config.globalProperties.$formatNumber = formatNumber
app.config.globalProperties.$getDayOfWeek = getDayOfWeek
app.use(router)
app.use(store)
app.use(ElementPlus, {locale: zhCn})
// app.use(NProgress)
app.mount('#app')
